<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref } from 'vue';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import Player from 'video.js/dist/types/player';
import posterImg from '../../assets/imgs/Lecture-intro.jpg'

const { src } = defineProps<{ src: string }>()

const videoPlayer = ref<HTMLVideoElement | null>(null);
let player: Player | null = null;

// Initialize Video.js when component mounts
onMounted(() => {
    if (!videoPlayer.value) return;

    const options = {
        html5: {
            vhs: {
                overrideNative: true
            },
            nativeAudioTracks: false,
            nativeVideoTracks: false
        },
        playsinline: true,
        controls: true,
        preload: 'auto',
        poster: posterImg,
        sources: [{ src }]
    }
    player = videojs(videoPlayer.value, options)
});

// Clean up Video.js instance before unmounting
onBeforeUnmount(() => {
    if (!player) return;
    player.dispose();
});
</script>

<template>
    <video ref="videoPlayer" playsinline class="video-js vjs-big-play-centered vjs-fill"></video>
</template>
